module.exports = __webpack_public_path__ + "static/media/theatre.95a882b7.png";